import React from 'react'
import CreatableSelect from 'react-select/creatable'
import { connectField, filterDOMProps } from 'uniforms'

interface TagOption {
  value: string
  label: string
}

const SelectTags = ({
  label,
  name,
  tags = [],
  // uniforms fields
  onChange,
  id,
  value = [],
  inputRef,
  ...props
}) => {
  // Convert string array to option objects
  const options: TagOption[] = tags.filter(Boolean).map(tag => ({ 
    value: tag, 
    label: tag 
  }))

  // Convert current value (array of strings) to option objects
  const selectedValues: TagOption[] = Array.isArray(value) 
    ? value.map(val => ({ value: val, label: val }))
    : []

  return (
    <section className="input-row" {...filterDOMProps(props)}>
      {label && <label htmlFor={id}>{label}</label>}

      <CreatableSelect
        name={name}
        placeholder="Type or select from the list..."
        options={options}
        isMulti={true}
        isClearable={true}
        id={id}
        ref={inputRef}
        value={selectedValues}
        classNamePrefix="cl-select"
        styles={{
          input: provided => ({
            ...provided,
            border: "none",
            padding: 0,
            margin: 0,
            boxShadow: "none",
            background: "transparent",
          }),
          container: (provided) => ({
            ...provided,
            maxWidth: '82%',
            width: '82%'
          })
        }}
        onChange={(selectedOptions) => {
          const values = selectedOptions ? selectedOptions.map(opt => opt.value) : []
          onChange(values)
        }}
        onCreateOption={(inputValue) => {
          const newValue = [...value, inputValue]
          onChange(newValue)
        }}
      />
    </section>
  )
}

export default connectField(SelectTags)
